import React, { Component } from 'react';
import './ActivityTracker.css';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { cdnPath } from '../../constants/config';

class CurrentGoal extends Component {
    constructor(props){
        super(props);
        this.state = {

        };
    }

    getIcon = () => {
        if(this.props.value >= this.props.goal){
            switch(this.props.color){
                case 'red':
                return `https://${cdnPath}/mobilenext/images/red-small-3x.png`;
                case 'green':
                return `https://${cdnPath}/mobilenext/images/green-small-3x.png`;
                case 'blue':
                return `https://${cdnPath}/mobilenext/images/blue-small-3x.png`;
            }
        }
        else{
            return `https://${cdnPath}/mobilenext/images/gray-small-3x.png`;
        }
    }
    
    getColor = () => {
        switch(this.props.color){
            case 'red':
            return "#E85E56"
            case 'green':
            return "#85B01E"
            case 'blue':
            return "#4AB4E6"
        }
    }

    render(){
        var primary = getMuiTheme(window.muiTheme).palette.primary1Color;
        return (
            <div className={`activity-goal-table`}>
                {/* <div className={this.props.value >= this.props.goal ? 'running-guy-color':'running-guy-gray'}/></div> */}
                <div><img src={this.getIcon()} style={{width:'65px'}} /></div>
                <div><span className={'grey-font activity-goal-name'}>{this.props.name}</span></div>
                <div className={'activity-goal-value-container'}><span className={`${this.props.color} activity-goal-value`} style={{color:this.getColor()}}>{this.props.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                <div><span className={'grey-font activity-goal-goal'}>of {this.props.goal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
            </div>
        )
    }
}

export default CurrentGoal;



// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/CurrentGoal.js